import React, { useId } from 'react';
import Form from 'react-bootstrap/Form';
import PropTypes from "prop-types";
import './RadioButtonGroup.css';
import { useTranslation } from "react-i18next";
import Message from "./Message";

const RadioButtonGroup = ({ options, onChange, value, message, ...rest }) => {
    const { t } = useTranslation();
    const id = useId();
    const messageId = `${id}-message`;
    const isInvalid = !!message?.content;
    const uniqueRadioGroup = `radiogroup-${id}`;

    return (
        <>
            {options.map(option =>
                <Form.Check
                    className="radio-button-group"
                    type="radio"
                    checked={value === option.value}
                    key={option.value}
                    value={option.value}
                    id={`publicity-${option.value}-${id}`}
                    label={t(option.label)}
                    aria-label={t(option.label)}
                    name={uniqueRadioGroup}
                    onChange={(e) => onChange(e.target.value)}
                    {...rest}
                />
            )}
            {isInvalid && (
                <Message messageId={messageId} type={message.type}>
                    {message.content}
                </Message>
            )}
        </>
    );
};

RadioButtonGroup.propTypes = {
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
    message: PropTypes.shape({
        content: PropTypes.string,
        type: PropTypes.oneOf(['light', 'neutral', 'warning'])
    })
};

export default RadioButtonGroup;